import React from 'react'
import { useTranslation } from 'react-i18next';
import { useDocuments } from '../hooks';
import { GetViewType } from 'src/utils/view-type';
// import Search from 'src/components/search/search';
// import Sort from 'src/components/sort/sort';
import { CheckIcon, Close, EditIcon } from 'src/icons/icons';
import Filter from 'src/components/filter/filter';
import Loading from 'src/components/Loading';
import { DeleteDocument } from './components/DeleteDocument';
import { MutateDocument } from './components/MutateDocument';

export const DocumentList = () => {

    const viewType = GetViewType()

    const { data, isError } = useDocuments()

    const { t } = useTranslation();

    if (isError)
        return <span>{t('ErrorInLoadingJobLevels')}</span>


    else if (data) {

        const documents = data.details.data.data




        return (

            viewType === "WEB" ?
                <div className="relative overflow-x-auto  bg-white rounded-lg  flex flex-col items-center w-full !mt-5 border border-1 border-gray-300 overflow-hidden ">
                    <table className="w-full text-sm text-gray-500">
                        <thead className="text-xs text-gray-700 uppercase ">
                            <tr className={"border-b border-gray-400 text-center"}>
                                <th scope="col" className="px-6 py-3   font-normal text-gray-600 text-sm">
                                    <div className={"mt-1"}>
                                        {t("row")}
                                    </div>
                                </th>
                                <th scope="col" className="px-6 py-3   font-normal text-gray-600 text-sm">
                                    <div className={"mt-1  text-center"}>
                                        {/* <Sort data={data} sortKey={"name"}  onSort={(e)=> handleSort(e)}/> */}
                                        {t("Title")}
                                    </div>
                                </th>
                                <th scope="col" className="px-6 py-3  font-normal text-gray-600 text-sm">
                                    {t("DocType")}
                                    {/* <Search onChange={handleSearch}/> */}
                                </th>
                                <th scope="col" className="px-6 py-3  font-normal text-gray-600 text-sm">
                                    {t("Key")}
                                    {/* <Search onChange={handleSearch}/> */}
                                </th>
                                <th scope="col" className="px-6 py-3  font-normal text-gray-600 text-sm">
                                    {t("IsOptional")}
                                    {/* <Search onChange={handleSearch}/> */}
                                </th>
                                <th scope="col" className="px-6 py-3  font-normal text-gray-600 text-sm">
                                    {t("Creditable")}
                                    {/* <Search onChange={handleSearch}/> */}
                                </th>
                                <th scope="col" className="px-6 py-3  font-normal text-gray-600 text-sm">
                                    {t("Operation")}
                                    {/* <Search onChange={handleSearch}/> */}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {documents?.map((item, index) => (
                                <tr key={index} className="bg-white border-b border-gray-400 text-center">
                                    <td className="px-6 py-4 text-center">
                                        <div className={"text-gray-500 text-sm mt-1"}>
                                            {index + 1}
                                        </div>
                                    </td>
                                    <td className="px-6 py-4  text-primary-400 text-base font-semibold">
                                        <div className={"mt-1"}>
                                            {item?.title}
                                        </div>
                                    </td>
                                    <td className="px-6 py-4  text-primary-400 text-base font-semibold">
                                        <div className={"mt-1"}>
                                            {item?.type=='CREW' ? t('crew') :""}
                                            {item?.type=='VISA' ? t('visa') :""}
                                        </div>
                                    </td>
                                    <td className="px-6 py-4  text-primary-400 text-base font-semibold">
                                        <div className={"mt-1"}>
                                            {item?.key}
                                        </div>
                                    </td>
                                    <td className="px-6 py-4  text-primary-400 text-base font-semibold">
                                        <div className={"mt-1 flex flex-row justify-center"}>
                                            {item?.is_optional ? <CheckIcon className='size-5'/> : <Close color='red' /> }
                                        </div>
                                    </td>
                                    <td className="px-6 py-4  text-primary-400 text-base font-semibold">
                                        <div className={"mt-1 flex flex-row justify-center"}>
                                            {item?.is_creditable ? <CheckIcon className='size-5'/> : <Close color='red' /> }
                                        </div>
                                    </td>
                                    <td className="px-6 py-4 text-right">
                                        <div className={"flex justify-center cursor-pointer"}>
                                            <MutateDocument mode='edit' record={item} >
                                                <EditIcon />
                                            </MutateDocument>

                                            <DeleteDocument id={item.id} />
                                        </div>
                                    </td>
                                </tr>
                            ))}

                            {documents.length == 0 && <tr className='py-4'>
                                <td colSpan={4} className='p-2 text-center'>
                                    <span className='text-gray-500 bg-white text-center p- 4 my-2 '> {t('noOptions')}     </span>
                                </td>
                            </tr>}

                        </tbody>
                    </table>
                </div>
                :
                <div className={"grid gap-3 mt-3"}>
                    <div className={"bg-white p-3 rounded-lg flex gap-5"}>
                        <Filter />
                        {/* <div className={"w-full"}>
                        <Search onChange={handleSearch}/>
                      </div> */}
                    </div>
                    {/* {
                      data?.data?.map((item , index) => {
                        return(
                          <div className={"flex p-4 rounded-lg bg-white"}>
                            <div className={"flex w-full"}>
                              <div className={"ml-5 min-w-7"}>{index+1}</div>
                              <div className={"flex w-full flex-wrap gap-y-8 justify-between"}>
                                <div className={"flex w-1/3"}>{item?.name}</div>
                                <div className={"flex w-1/3 justify-center"}>
                                  <div className={"flex justify-center cursor-pointer"}>
                                    <button onClick={()=>handleEdit(item)}>
                                      <EditIcon/>
                                    </button>
                                    <button onClick={()=>handleDelete(item)}>
                                      <DeleteIcon/>
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )
                      })
                    } */}
                </div>

        )
    }

    return <div className='flex flex-col gap-4 items-center justify-center border bg-white rounded-lg h-28 aspect-video'>
        <Loading />
    </div>
}
